export default function Hero() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const stats = [
    { value: '10万+', label: '影视资源' },
    { value: '每日更新', label: '热播内容不间断' },
    { value: '高清流畅', label: '极速播放不缓冲' },
  ];

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-200/80 via-background-50 to-background-100" />
      <div className="absolute inset-0 opacity-[0.06] bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-primary-400 via-transparent to-transparent" />

      <div className="relative w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto flex flex-col lg:flex-row items-center gap-8 lg:gap-16 py-16 md:py-24">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/15 border border-primary-500/30 mb-6">
              <i className="ri-fire-line text-primary-400 text-sm w-4 h-4 flex items-center justify-center"></i>
              <span className="text-xs text-primary-400 whitespace-nowrap">热门影视聚合 · 每日更新</span>
            </div>

            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-foreground-50 leading-tight mb-4">
              69视频
              <span className="block text-primary-400 text-xl md:text-3xl lg:text-4xl mt-2">
                免费影视在线观看平台
              </span>
            </h1>

            <p className="text-sm md:text-base text-primary-300/80 font-medium mb-6">
              海量资源 · 极速播放 · 永久免费
            </p>

            <p className="text-sm md:text-base text-foreground-300 leading-relaxed mb-8 max-w-xl mx-auto lg:mx-0">
              69视频汇聚西瓜视频免费、91在线视频等主流影视资源入口，提供电影大片、电视剧全集、综艺节目、动漫番剧等海量内容。
              支持高清画质与流畅播放，无需注册即可免费在线观看，每日持续更新最新热播内容，是您追剧看片的优质选择。
            </p>

            <div className="flex flex-wrap justify-center lg:justify-start gap-6 md:gap-10 mb-8">
              {stats.map((s) => (
                <div key={s.label} className="text-center">
                  <div className="text-xl md:text-2xl font-bold text-accent-400 whitespace-nowrap">{s.value}</div>
                  <div className="text-xs text-foreground-400 mt-1 whitespace-nowrap">{s.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                onClick={(e) => handleClick(e, '#index')}
                className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg w-5 h-5 flex items-center justify-center"></i>
                立即观看
              </a>
              <a
                href="#app"
                onClick={(e) => handleClick(e, '#app')}
                className="inline-flex items-center gap-2 px-8 py-3 border border-foreground-300/30 text-foreground-200 hover:text-primary-400 hover:border-primary-400/40 font-medium rounded-lg transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-download-line text-lg w-5 h-5 flex items-center justify-center"></i>
                下载APP
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[520px] lg:max-w-none">
            <div className="relative rounded-2xl overflow-hidden aspect-[16/10] bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20film%20strip%20and%20movie%20reel%20abstract%20composition%20with%20warm%20golden%20and%20amber%20lighting%20on%20dark%20background%2C%20luxurious%20theater%20aesthetic%20with%20soft%20bokeh%20particles%2C%20streaming%20platform%20vibe%2C%20premium%20entertainment%20atmosphere%2C%20artistic%20photography%20with%20rich%20contrast%20and%20cinematic%20color%20grading&width=1040&height=650&seq=hero-cinema-01&orientation=landscape"
                alt="69视频影视平台主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50/60 via-transparent to-transparent" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}